module.exports = __webpack_public_path__ + "static/media/sideimg.e5616fc9.jpg";